@if (cycled()) {
  <mat-icon
    svgIcon="icon_warning_runtime_16"
    blazeTooltip="This workflow will not run until the loop is resolved. Adjust your triggers or workflows to remove the loop."
    class="tooltip"
    data-cy="TriggersWarnings:cycled"
  />
}
@if (disabled()) {
  <mat-icon
    svgIcon="icon_warning_16"
    blazeTooltip="Only one workflow can be active per action."
    class="tooltip"
    data-cy="TriggersWarnings:disabled"
  />
}
